import { render, staticRenderFns } from "./ValidasiAktivitas.vue?vue&type=template&id=b84ae296&scoped=true&lang=html&"
import script from "./ValidasiAktivitas.vue?vue&type=script&lang=js&"
export * from "./ValidasiAktivitas.vue?vue&type=script&lang=js&"
import style0 from "./ValidasiAktivitas.vue?vue&type=style&index=0&id=b84ae296&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84ae296",
  null
  
)

export default component.exports